module.exports = __webpack_public_path__ + "img/VisaDebit.37c40c1e.png";